// Final authored notices, request results, and mobile table labels.
export const finalOperationsArabicTranslations: Record<string, string> = {
  "{0} lead(s) downloaded. Ownership and Lead Warehouse are unchanged.": "تم تنزيل {0} ليد. الموظف المسؤول ومخزن الليدات زي ما هم.",
  "Moved {0} leads. Each movement has been recorded.": "تم نقل {0} ليد. كل عملية نقل اتسجلت.",
  "Withdrawn {0} leads to the pool.": "اتسحب {0} ليد للمخزن.",
  "Distributed {0} leads to the selected employees.": "اتوزّع {0} ليد على الموظفين المحددين.",
  "No leads are available for this operation. Refresh the list.": "مفيش ليدات متاحة للعملية دي. حدّث القائمة.",
  "Could not preview the operation": "مش قادرين نعمل معاينة للعملية",
  "The operation failed. Preview again.": "العملية فشلت. اعمل معاينة تاني.",
  "Could not preview the export": "مش قادرين نعمل معاينة للتصدير",
  "Could not download the export": "مش قادرين ننزّل التصدير",
  "Unable to load campaigns": "مش قادرين نحمّل الحملات",
  "Unable to complete the operation": "مش قادرين نكمّل العملية",
  "Unable to complete the request (HTTP {0}).": "مش قادرين نكمّل الطلب (HTTP {0}).",
  "Rollback request submitted for approval.": "طلب التراجع اتبعت للموافقة.",
  "Unable to request rollback": "مش قادرين نبعت طلب التراجع",
  "Recipient is not available from the current request data.": "الموظف المستلم مش متاح في بيانات الطلب الحالي.",
  "Decision reason is required.": "سبب القرار مطلوب.",
  "Unable to update the request.": "مش قادرين نحدّث الطلب.",
  "Lead count": "عدد الليدات",
  "Responsible": "الموظف المسؤول",
  "Pool assignment": "إسناد من المخزن",
  "Source distribution": "توزيع من المصدر",
  "Manual transfer": "نقل يدوي",
  "{0} visible New leads per salesperson": "{0} ليد جديد ظاهر لكل موظف سيلز",
  "Select at least one eligible lead": "اختار ليد متاح واحد على الأقل",
  "Select an active target employee": "اختار موظف مستهدف نشط",
  "Select current owner and new owner": "اختار الموظف الحالي والجديد",
  "Choose a different new owner": "اختار موظف جديد مختلف",
  "Set maximum leads": "حدد أقصى عدد ليدات",
  "Select one or more target salespeople": "اختار موظف سيلز مستهدف واحد أو أكتر",
  "Choose a campaign, course, or pipeline status": "اختار حملة أو كورس أو حالة في قائمة العمل",
  "Select target employee": "اختار الموظف المستهدف",
  "Reject note is required": "ملاحظة الرفض مطلوبة",
  "A decision note is required for reject or return": "ملاحظة القرار مطلوبة للرفض أو الإرجاع",
  "Pending": "مستني المراجعة",
  "Approved": "تمت الموافقة",
  "Rejected": "مرفوض",
  "Returned for Edit": "اترجّع للتعديل",
  "Executed": "تم التنفيذ",
  "Completed": "مكتمل",
  "Cancelled": "ملغي",
  "Failed": "فشل",
  "In progress": "جاري التنفيذ",
  "Available": "متاح",
  "Used": "تم الاستخدام",
  "Held": "في المخزن",
  "Redistributed": "تم إعادة التوزيع",
  "Pending approval": "مستني الموافقة",
  "Pending Upper Management Approval": "مستني موافقة الإدارة العليا",
  "No answer": "مفيش رد",
  "Unreceived": "مااتفتحش",
  "No action": "مفيش إجراء",
  "Queue": "قائمة الانتظار",
  "Other": "أخرى",
  "Stage cannot be withdrawn": "المرحلة دي مش متاحة للسحب",
  "Stage entry not recorded": "وقت الدخول للمرحلة مش مسجل",
  "No-answer threshold not met": "شرط سحب ليدات مفيش رد لسه مااتحققش",
  "Valid follow-up": "فيه متابعة سارية",
  "Inactivity period not elapsed": "مدة عدم النشاط لسه ماخلصتش",
  "Activity recorded since stage entry": "فيه نشاط مسجل من وقت الدخول للمرحلة",
  "Stage waiting period not elapsed": "مدة انتظار المرحلة لسه ماخلصتش",
};

export const finalOperationsEnglishTranslations: Record<string, string> = {
  "تم سحب {0} ليد إلى المخزن.": "Withdrawn {0} leads to the pool.",
  "تم توزيع {0} ليد على الموظفين المحددين.": "Distributed {0} leads to the selected employees.",
  "لا توجد ليدات متاحة لهذه العملية. حدّث القائمة.": "No leads are available for this operation. Refresh the list.",
  "تعذرت المعاينة": "Could not preview the operation",
  "تعذرت العملية. أعد المعاينة.": "The operation failed. Preview again.",
  "pending": "Pending",
  "approved": "Approved",
  "rejected": "Rejected",
  "returned for edit": "Returned for Edit",
  "returned_for_edit": "Returned for Edit",
  "executed": "Executed",
  "completed": "Completed",
  "cancelled": "Cancelled",
  "failed": "Failed",
  "in progress": "In progress",
  "in_progress": "In progress",
  "available": "Available",
  "used": "Used",
  "held": "Held",
  "redistributed": "Redistributed",
  "pending approval": "Pending approval",
  "pending_approval": "Pending approval",
  "pending upper management approval": "Pending Upper Management Approval",
  "pending_upper_management_approval": "Pending Upper Management Approval",
  "no answer": "No answer",
  "no_answer": "No answer",
  "unreceived": "Unreceived",
  "noaction": "No action",
  "queue": "Queue",
  "stage not withdrawable": "Stage cannot be withdrawn",
  "stage entry not recorded": "Stage entry not recorded",
  "no answer threshold not met": "No-answer threshold not met",
  "valid follow up": "Valid follow-up",
  "inactivity period not elapsed": "Inactivity period not elapsed",
  "recorded activity since stage entry": "Activity recorded since stage entry",
  "stage waiting period not elapsed": "Stage waiting period not elapsed",
};
